import { RobotoButton } from "@/shared/components/RobotoButton";
import { Dimensions } from "@/shared/hooks";

import { PlotManager } from "../../PlotManager";
import { Extents } from "../../PlotRenderer";
import { Viewport } from "../../Viewport";
import { pixelRegionToViewport } from "../chartRegionToTimeRange";

interface ZoomFromSelectionButtonProps {
  chartExtents: Extents;
  onClose: () => void;
  plotManager: PlotManager | null;
  selectedRegion: Dimensions;
}

export function ZoomFromSelectionButton({
  chartExtents,
  onClose,
  plotManager,
  selectedRegion,
}: ZoomFromSelectionButtonProps) {
  return (
    <RobotoButton
      eventName={"ZoomFromSelectionClicked"}
      variant="text"
      onClick={function zoomToRegion() {
        plotManager?.applyViewport(
          Viewport.fromDomainAndRange({
            viewportDomain: pixelRegionToViewport(selectedRegion, chartExtents),
            viewportRange: chartExtents.data.viewportRange,
            dataDomain: chartExtents.data.fullDomain,
            dataRange: chartExtents.data.fullRange,
          }),
          // Zoom both axes whatever the panel's sync mode: that mode picks the
          // axes shared with other panels, and a panel that shares none still
          // zooms itself. The y bounds passed are the ones already on screen,
          // so only x moves.
          "xy",
        );
        onClose();
      }}
    >
      Zoom
    </RobotoButton>
  );
}
